export default {
  computed: {
    season() {
      let seasons = [this.$store.state.currentSeason, this.$store.state.upcomingSeason];
      let id = this.$route.params.seasonId;
      return seasons.filter(season => season != null && season.id == id)[0];
    },
    league() {
      let leagues = this.season.leagues;
      let id = this.$route.params.leagueId;
      return leagues.filter(league => league != null && league.id == id)[0];
    },
    camp() {
      let camps = this.season.camps;
      let id = this.$route.params.campId;
      return camps.filter(camp => camp != null && camp.id == id)[0];
    },
  }
}
